import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { AppService } from '../service/app.service';
import { CryptoService } from '../helper/crypto.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private router: Router,
        public toastController: ToastController,
        public appService: AppService,
        public cryptoService: CryptoService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let tokenCrypto = localStorage.getItem('auth_key') ? localStorage.getItem('auth_key') : '';
        let token = this.cryptoService.decryptData(tokenCrypto);

        if (token) {
            request = request.clone({
                setHeaders: {
                    'X-Api-Key': token
                }
            });
        }

        if (!request.headers.has('Content-Type')) {
            request = request.clone({
                setHeaders: {
                    'content-type': 'application/json'
                }
            });
        }

        request = request.clone({
            headers: request.headers.set('Accept', 'application/json')
        });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    localStorage.removeItem('auth_key');
                    this.router.navigate(['login']);
                    // this.appService.toastMessage("Authentication required");
                }
                return throwError(error);
            }));
    }

    async presentToast(msg) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 2000,
            position: 'bottom'
        });
        toast.present();
    }

}
